const initialState = {
    loading: true,
    error: null,
    profile: null,
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'DUALMATCH:FETCH_PROFILE':
            return {
                ...state,
                loading: true,
                error: null,
            };
        case 'DUALMATCH:FETCH_PROFILE_SUCCESS':
            return {
                ...state,
                loading: false,
                error: null,
                profile: action.data,
            };
        case 'DUALMATCH:FETCH_PROFILE_FAILURE':
            return {
                ...state,
                loading: false,
                error: true,
            };
        case 'DUALMATCH:UPDATE_MATCH_PROFILE':
            return {
                ...state,
                profile: action.data.profile,
            };
        default:
            return state;
    }
}

export default app;
